/**
 * Tracking: GA4 ecommerce events in the Google Tag Manager dataLayer, and Klaviyo onsite events.
 *
 * Templates describe page events as JSON, so no Twig ends up inside JavaScript:
 *   <script type="application/json" data-track>{{ { event: 'view_item', ecommerce: {…}, klaviyo: { event: 'Viewed Product', properties: {…} } }|json_encode|raw }}</script>
 * Interactive events go through window.track() with the same shape, e.g. add_to_cart in cart.js.
 * `klaviyo.identify` ({ email }) identifies the visitor before the Klaviyo event is sent.
 *
 * Amounts must be numbers with decimals (49.95), never parseInt'ed. GTM itself is loaded by SEOmatic,
 * in production only; elsewhere the dataLayer just fills up. Klaviyo calls are skipped while the Klaviyo
 * onsite script (window.klaviyo) isn't on the page.
 */

window.dataLayer = window.dataLayer || [];

window.track = function ({ event, ecommerce, klaviyo } = {}) {
    if (event) {
        if (ecommerce) {
            // Clear the previous ecommerce object, GA4 would merge it into this one otherwise
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({ event, ecommerce });
        } else {
            window.dataLayer.push({ event });
        }
    }

    if (klaviyo && window.klaviyo) {
        if (klaviyo.identify) {
            window.klaviyo.identify(klaviyo.identify);
        }
        if (klaviyo.event) {
            window.klaviyo.track(klaviyo.event, klaviyo.properties ?? {});
        }
    }
};

function trackScripts(root) {
    root.querySelectorAll('script[type="application/json"][data-track]').forEach((script) => {
        try {
            window.track(JSON.parse(script.textContent));
        } catch (error) {
            console.error('Tracking: invalid event JSON', error);
        }
    });
}

document.addEventListener('DOMContentLoaded', () => trackScripts(document));

// Sprig components render events too, after the page loads (the mini cart identifies the visitor)
document.addEventListener('htmx:afterSettle', (event) => trackScripts(event.target));
